import { Button, Card, CardBody, CardImg, CardTitle, Col, Row } from 'reactstrap';
import { ContentBlock } from '../Shared/Content/ContentBlock';
import { ContentHeading } from '../Shared/Content/ContentHeading';
import { ContentBody } from '../Shared/Content/ContentBody';

interface IProps {
    fieldCaseStudiesSectionTitle: string
    fieldCaseStudyLeft: any,
    fieldCaseStudyRight: any
}

export const CaseStudies = ({ fieldCaseStudiesSectionTitle, fieldCaseStudyLeft, fieldCaseStudyRight }: IProps) => {
    return (
            <ContentBlock className="caseStudies">
                <ContentHeading title={fieldCaseStudiesSectionTitle} />
                <ContentBody>
                    <Row className="contentCardBlock caseStudyCard justify-content-between">
                        <Col className={'col col-12'} sm={6}>
                            <Card>
                                {(() => {
                                    // check if image data exists coming from CMS
                                    if (fieldCaseStudyLeft.fieldImage !== undefined && fieldCaseStudyLeft.fieldImage !== null) {
                                        return (
                                            <div className={'cardImageContainer'}>
                                                {/* build image element */}
                                                <CardImg
                                                    variant="top"
                                                    style={{ objectPosition: (fieldCaseStudyLeft.fieldImage.focalPoint.x * 100) + '% ' + (fieldCaseStudyLeft.fieldImage.focalPoint.y * 100) + '% ' }}
                                                    src={fieldCaseStudyLeft.fieldImage.url}
                                                    alt={fieldCaseStudyLeft.fieldImage.alt}
                                                    title={fieldCaseStudyLeft.fieldImage.title} width={""} height={""}
                                                />
                                            </div>
                                        );
                                    }
                                })()}
                                <CardBody className="cardBody">
                                    <CardTitle className="cardHeading">
                                        <div className="heading5">{fieldCaseStudyLeft.fieldTitle}</div>
                                    </CardTitle>
                                    <div className="cardBodyText" dangerouslySetInnerHTML={{ __html: fieldCaseStudyLeft.fieldBodyText }} />
                                </CardBody>
                                <div className="cardButton">
                                    <Button className="tertiaryButton iconRightArrow" target={'_blank'} href={fieldCaseStudyLeft.fieldUrl}>READ CASE STUDY</Button>
                                </div>
                            </Card>
                        </Col>
                        <Col className={'col col-12'} sm={6}>
                            <Card>
                                {(() => {
                                    // check if image data exists coming from CMS
                                    if (fieldCaseStudyRight.fieldImage !== undefined && fieldCaseStudyRight.fieldImage !== null) {
                                        return (
                                            <div className={'cardImageContainer'}>
                                                {/* build image element */}
                                                <CardImg
                                                    variant="top"
                                                    style={{ objectPosition: (fieldCaseStudyRight.fieldImage.focalPoint.x * 100) + '% ' + (fieldCaseStudyRight.fieldImage.focalPoint.y * 100) + '% ' }}
                                                    src={fieldCaseStudyRight.fieldImage.url}
                                                    alt={fieldCaseStudyRight.fieldImage.alt}
                                                    title={fieldCaseStudyRight.fieldImage.title}
                                                />
                                            </div>
                                        );
                                    }
                                })()}
                                <CardBody className="cardBody">
                                    <CardTitle className="cardHeading">
                                        <div className="heading5">{fieldCaseStudyRight.fieldTitle}</div>
                                    </CardTitle>
                                    <div className="cardBodyText" dangerouslySetInnerHTML={{ __html: fieldCaseStudyRight.fieldBodyText }} />
                                </CardBody>
                                <div className="cardButton">
                                    <Button className="tertiaryButton iconRightArrow" target={'_blank'} href={fieldCaseStudyRight.fieldUrl}>READ CASE STUDY</Button>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </ContentBody>
            </ContentBlock>
    );
};
